import React, { useState, useEffect } from 'react';
import Sidebar from '../components/Sidebar';
import axios from 'axios';

const API = 'https://app.b3rastreamento.com.br/api';

const categorias = [
  { value: 'funcionalidade', label: '⚡ Nova Funcionalidade', cor: '#378ADD' },
  { value: 'melhoria', label: '🔧 Melhoria', cor: '#F59E0B' },
  { value: 'bug', label: '🐛 Bug / Problema', cor: '#E24B4A' },
  { value: 'design', label: '🎨 Design / Visual', cor: '#7C3AED' },
  { value: 'outro', label: '💬 Outro', cor: '#666' },
];

const prioridades = [
  { value: 'baixa', label: 'Baixa', cor: '#22C55E' },
  { value: 'media', label: 'Média', cor: '#F59E0B' },
  { value: 'alta', label: 'Alta', cor: '#E24B4A' },
];

function Sugestoes() {
  const [sidebarAberta, setSidebarAberta] = useState(false);
  const [sugestoes, setSugestoes] = useState([]);
  const [modalAberto, setModalAberto] = useState(false);
  const [salvando, setSalvando] = useState(false);
  const [filtroStatus, setFiltroStatus] = useState('');
  const [filtroCategoria, setFiltroCategoria] = useState('');
  const [form, setForm] = useState({ titulo: '', descricao: '', categoria: 'funcionalidade', prioridade: 'media' });

  const token = localStorage.getItem('token');
  const usuario = JSON.parse(localStorage.getItem('usuario') || '{}');
  const isSuperadmin = usuario.perfil === 'superadmin';
  const headers = { Authorization: `Bearer ${token}` };

  useEffect(() => { carregarSugestoes(); }, []);

  const carregarSugestoes = async () => {
    try {
      const res = await axios.get(`${API}/sugestoes`, { headers });
      setSugestoes(res.data);
    } catch (err) { console.error(err); }
  };

  const salvar = async () => {
    if (!form.titulo || !form.descricao) { alert('Título e descrição são obrigatórios!'); return; }
    setSalvando(true);
    try {
      await axios.post(`${API}/sugestoes`, form, { headers });
      setModalAberto(false);
      setForm({ titulo: '', descricao: '', categoria: 'funcionalidade', prioridade: 'media' });
      carregarSugestoes();
    } catch (err) { alert(err.response?.data?.erro || 'Erro ao salvar'); }
    setSalvando(false);
  };

  const atualizarStatus = async (id, status) => {
    try {
      await axios.patch(`${API}/sugestoes/${id}/status`, { status }, { headers });
      carregarSugestoes();
    } catch (err) { console.error(err); }
  };

  const curtir = async (id) => {
    try {
      await axios.patch(`${API}/sugestoes/${id}/curtir`, {}, { headers });
      carregarSugestoes();
    } catch (err) { console.error(err); }
  };

  const statusOpcoes = [
    { value: 'pendente', label: '⏳ Pendente', cor: '#F59E0B', bg: '#FAEEDA' },
    { value: 'analisando', label: '🔍 Analisando', cor: '#378ADD', bg: '#E6F1FB' },
    { value: 'aprovada', label: '✅ Aprovada', cor: '#0F6E56', bg: '#E1F5EE' },
    { value: 'concluida', label: '🎉 Concluída', cor: '#7C3AED', bg: '#F3E8FF' },
    { value: 'recusada', label: '❌ Recusada', cor: '#A32D2D', bg: '#FCEBEB' },
  ];

  const getStatus = (status) => statusOpcoes.find(s => s.value === status) || statusOpcoes[0];
  const getCategoria = (cat) => categorias.find(c => c.value === cat) || categorias[4];

  const sugestoesFiltradas = sugestoes.filter(s => {
    if (filtroStatus && s.status !== filtroStatus) return false;
    if (filtroCategoria && s.categoria !== filtroCategoria) return false;
    return true;
  });

  return (
    <div style={{ minHeight: '100vh', background: '#f5f5f5' }}>
      <Sidebar aberta={sidebarAberta} setAberta={setSidebarAberta} />

      <div style={{ background: '#1D9E75', padding: '0 24px', height: '60px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', position: 'fixed', top: 0, left: 0, right: 0, zIndex: 500, boxShadow: '0 2px 10px rgba(0,0,0,0.2)' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          <button onClick={() => setSidebarAberta(!sidebarAberta)} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '22px', color: 'white' }}>{sidebarAberta ? '✕' : '☰'}</button>
          <span style={{ color: 'white', fontWeight: '700', fontSize: '18px' }}>💡 Sugestões</span>
        </div>
        <button onClick={() => setModalAberto(true)} style={{ background: 'rgba(255,255,255,0.2)', color: 'white', border: '1px solid rgba(255,255,255,0.4)', borderRadius: '8px', padding: '8px 16px', cursor: 'pointer', fontWeight: '600', fontSize: '14px' }}>
          + Nova Sugestão
        </button>
      </div>

      <div style={{ marginTop: '60px', padding: '24px' }}>

        {/* Cards de resumo */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: '12px', marginBottom: '20px' }}>
          {statusOpcoes.map((s, i) => (
            <div key={i} onClick={() => setFiltroStatus(filtroStatus === s.value ? '' : s.value)}
              style={{ background: 'white', borderRadius: '10px', padding: '14px', boxShadow: '0 1px 4px rgba(0,0,0,0.08)', borderLeft: `4px solid ${s.cor}`, cursor: 'pointer', opacity: filtroStatus && filtroStatus !== s.value ? 0.5 : 1, transition: 'opacity .2s' }}>
              <div style={{ fontSize: '20px', fontWeight: '700', color: s.cor }}>{sugestoes.filter(x => x.status === s.value).length}</div>
              <div style={{ fontSize: '12px', color: '#666', marginTop: '2px' }}>{s.label}</div>
            </div>
          ))}
        </div>

        {/* Filtros */}
        <div style={{ display: 'flex', gap: '8px', marginBottom: '16px', flexWrap: 'wrap' }}>
          {categorias.map(c => (
            <button key={c.value} onClick={() => setFiltroCategoria(filtroCategoria === c.value ? '' : c.value)}
              style={{ background: filtroCategoria === c.value ? c.cor : 'white', color: filtroCategoria === c.value ? 'white' : '#666', border: `1px solid ${filtroCategoria === c.value ? c.cor : '#ddd'}`, borderRadius: '8px', padding: '6px 14px', cursor: 'pointer', fontSize: '12px', fontWeight: '500' }}>
              {c.label}
            </button>
          ))}
        </div>

        {/* Lista de sugestões */}
        {sugestoesFiltradas.length === 0 ? (
          <div style={{ background: 'white', borderRadius: '12px', padding: '48px', textAlign: 'center', color: '#999', boxShadow: '0 1px 4px rgba(0,0,0,0.08)' }}>
            <div style={{ fontSize: '48px', marginBottom: '16px' }}>💡</div>
            <div style={{ fontSize: '16px', fontWeight: '500' }}>Nenhuma sugestão encontrada</div>
            <div style={{ fontSize: '13px', marginTop: '8px' }}>Clique em "+ Nova Sugestão" para enviar sua ideia!</div>
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            {sugestoesFiltradas.map((s, i) => {
              const st = getStatus(s.status);
              const cat = getCategoria(s.categoria);
              const prioridade = prioridades.find(p => p.value === s.prioridade) || prioridades[1];
              return (
                <div key={i} style={{ background: 'white', borderRadius: '12px', padding: '20px', boxShadow: '0 1px 4px rgba(0,0,0,0.08)', borderLeft: `4px solid ${cat.cor}` }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '16px' }}>
                    <div style={{ flex: 1 }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '6px', flexWrap: 'wrap' }}>
                        <span style={{ fontSize: '15px', fontWeight: '600', color: '#333' }}>{s.titulo}</span>
                        <span style={{ background: cat.cor + '20', color: cat.cor, padding: '2px 8px', borderRadius: '12px', fontSize: '11px', fontWeight: '500' }}>{cat.label}</span>
                        <span style={{ background: prioridade.cor + '20', color: prioridade.cor, padding: '2px 8px', borderRadius: '12px', fontSize: '11px', fontWeight: '500' }}>
                          {prioridade.label}
                        </span>
                        <span style={{ background: st.bg, color: st.cor, padding: '2px 8px', borderRadius: '12px', fontSize: '11px', fontWeight: '500' }}>{st.label}</span>
                      </div>
                      <div style={{ fontSize: '13px', color: '#555', lineHeight: '1.6', marginBottom: '10px' }}>{s.descricao}</div>
                      <div style={{ fontSize: '11px', color: '#999' }}>
                        Por {s.usuario_nome} — {new Date(s.criado_em).toLocaleDateString('pt-BR')}
                      </div>
                      {s.resposta && (
                        <div style={{ marginTop: '12px', background: '#E1F5EE', borderRadius: '8px', padding: '12px', fontSize: '13px', color: '#0F6E56' }}>
                          <strong>💬 Resposta:</strong> {s.resposta}
                        </div>
                      )}
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px' }}>
                      <button onClick={() => curtir(s.id)} style={{ background: s.curtido ? '#E1F5EE' : '#f0f0f0', color: s.curtido ? '#0F6E56' : '#666', border: 'none', borderRadius: '8px', padding: '8px 12px', cursor: 'pointer', fontSize: '18px' }}>
                        👍
                      </button>
                      <span style={{ fontSize: '13px', fontWeight: '600', color: '#333' }}>{s.curtidas || 0}</span>
                    </div>
                  </div>

                  {isSuperadmin && (
                    <div style={{ marginTop: '14px', paddingTop: '14px', borderTop: '1px solid #f0f0f0', display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                      {statusOpcoes.map(opt => (
                        <button key={opt.value} onClick={() => atualizarStatus(s.id, opt.value)}
                          style={{ background: s.status === opt.value ? opt.cor : '#f0f0f0', color: s.status === opt.value ? 'white' : '#666', border: 'none', borderRadius: '6px', padding: '4px 10px', cursor: 'pointer', fontSize: '11px', fontWeight: '500' }}>
                          {opt.label}
                        </button>
                      ))}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </div>

      {/* MODAL */}
      {modalAberto && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' }}>
          <div style={{ background: 'white', borderRadius: '16px', width: '560px', maxWidth: '100%', boxShadow: '0 20px 60px rgba(0,0,0,0.3)' }}>
            <div style={{ padding: '20px 24px', borderBottom: '1px solid #eee', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <h2 style={{ margin: 0, fontSize: '18px' }}>💡 Nova Sugestão</h2>
              <button onClick={() => setModalAberto(false)} style={{ background: 'none', border: 'none', fontSize: '24px', cursor: 'pointer', color: '#999' }}>×</button>
            </div>
            <div style={{ padding: '24px', display: 'flex', flexDirection: 'column', gap: '16px' }}>

              <div>
                <label style={{ fontSize: '12px', color: '#666', fontWeight: '600', display: 'block', marginBottom: '4px' }}>Categoria</label>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px' }}>
                  {categorias.map(c => (
                    <div key={c.value} onClick={() => setForm(prev => ({ ...prev, categoria: c.value }))}
                      style={{ padding: '8px 12px', borderRadius: '8px', border: `2px solid ${form.categoria === c.value ? c.cor : '#eee'}`, cursor: 'pointer', background: form.categoria === c.value ? c.cor + '15' : 'white', fontSize: '13px', fontWeight: form.categoria === c.value ? '600' : '400', color: form.categoria === c.value ? c.cor : '#333' }}>
                      {c.label}
                    </div>
                  ))}
                </div>
              </div>

              <div>
                <label style={{ fontSize: '12px', color: '#666', fontWeight: '600', display: 'block', marginBottom: '4px' }}>Prioridade</label>
                <div style={{ display: 'flex', gap: '8px' }}>
                  {prioridades.map(p => (
                    <button key={p.value} onClick={() => setForm(prev => ({ ...prev, prioridade: p.value }))}
                      style={{ flex: 1, background: form.prioridade === p.value ? p.cor : '#f0f0f0', color: form.prioridade === p.value ? 'white' : '#666', border: 'none', borderRadius: '8px', padding: '8px', cursor: 'pointer', fontSize: '13px', fontWeight: '500' }}>
                      {p.label}
                    </button>
                  ))}
                </div>
              </div>

              <div>
                <label style={{ fontSize: '12px', color: '#666', fontWeight: '600', display: 'block', marginBottom: '4px' }}>Título *</label>
                <input type="text" placeholder="Resumo da sugestão..." value={form.titulo}
                  onChange={e => setForm(prev => ({ ...prev, titulo: e.target.value }))}
                  style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #ddd', fontSize: '14px', boxSizing: 'border-box' }} />
              </div>

              <div>
                <label style={{ fontSize: '12px', color: '#666', fontWeight: '600', display: 'block', marginBottom: '4px' }}>Descrição *</label>
                <textarea placeholder="Descreva sua sugestão com detalhes..." value={form.descricao}
                  onChange={e => setForm(prev => ({ ...prev, descricao: e.target.value }))}
                  rows={4} style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #ddd', fontSize: '14px', boxSizing: 'border-box', resize: 'vertical' }} />
              </div>
            </div>
            <div style={{ padding: '16px 24px', borderTop: '1px solid #eee', display: 'flex', justifyContent: 'flex-end', gap: '12px' }}>
              <button onClick={() => setModalAberto(false)} style={{ background: '#f0f0f0', color: '#666', border: 'none', borderRadius: '8px', padding: '10px 20px', cursor: 'pointer', fontWeight: '600' }}>Cancelar</button>
              <button onClick={salvar} disabled={salvando} style={{ background: salvando ? '#ccc' : '#1D9E75', color: 'white', border: 'none', borderRadius: '8px', padding: '10px 24px', cursor: salvando ? 'not-allowed' : 'pointer', fontWeight: '600' }}>
                {salvando ? '⏳ Enviando...' : '✅ Enviar Sugestão'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Sugestoes;